import { useState } from "react";

import {
    AnalyticsAttributesProvider,
    Expand,
    Markdown,
    useAnalytics,
    useAnalyticsAttributes,
    useBreakpoints
} from "../../../components";
import { UiPricingPlanModel } from "../../../models";
import { FeatureList } from "../UiPricingGrid.styles";

const PlanFeatures = ({ model }: { model: UiPricingPlanModel }) => {
    const [open, setOpen] = useState(false);
    const [tracked, setTracked] = useState(false);
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    const breakpoints = useBreakpoints();
    const { entryTitle, accordionReadMore, featureList } = model.content;

    return (
        <FeatureList data-open={open}>
            {accordionReadMore && (
                <button
                    data-testid="readMore"
                    onClick={() => {
                        setOpen(!open);
                        if (!tracked) {
                            sendTrackEvent("pricingPlanFeaturesExpanded", {
                                ...analyticsAttributes,
                                event: "clicked",
                                eventComponent: "button",
                                label: accordionReadMore,
                                labelEnglish: "See what's included",
                                title: model.content.title,
                                uuid: `${model.id}_planFeatures`
                            });
                            setTracked(true);
                        }
                    }}
                >
                    {accordionReadMore}
                </button>
            )}
            {featureList && (
                <Expand show={open || breakpoints.includes("lg")}>
                    <AnalyticsAttributesProvider
                        value={{
                            labelEnglish: entryTitle
                        }}
                    >
                        <Markdown>{featureList}</Markdown>
                    </AnalyticsAttributesProvider>
                </Expand>
            )}
        </FeatureList>
    );
};

export default PlanFeatures;
